var _ = require('underscore');
var $ = require('jquery');
var Backbone = require('backbone');
var Marionette = require('marionette');
var Behaviors = require('Behaviors');
var Dropdown = require('Dropdown');
var Entities = require('Entities');
var Validation = require('validation');
var Labels = EY.Consultation.Labels;
var Configuration = EY.Consultation.Lookups.Configuration;
var Resources = EY.Consultation.Resources;
var RecordAddTopic = require("RecordAddTopic");
var Geographies = new Entities.Geographies(Resources.Geography);
var StatusType = EY.Consultation.Lookups.StatusType;


var Geography = Marionette.View.extend({
    initialize: function () {
        var record = this.options.record;
        var index = record.get('geographyId').slice(1, -1).split('/');
        var path = record.get('geographyTypePath').slice(1, -1).split('/');
        var type = record.get('geographyTypePath');

        this.model = new Backbone.Model({
            office: this.text('Office', index, path, type),
            subcountry: this.text('SubCountry', index, path, type),
            country: this.text('Country', index, path, type),
            region: this.text('Region', index, path, type)
        });
    },
    template: '#recordGeographyLabels',
    ui: {
        region: '#regionSection',
        country: '#countrySection',
        subcountry: '#subcountrySection',
        office: '#officeSection'
    },
    onRender: function () {
        var configuration = this.options.record.get('configuration');

        if (configuration.DisplaySubCountry) {
            this.ui.region.addClass('hidden');
            this.ui.subcountry.removeClass('hidden');
            this.ui.country.removeClass('col-md-offset-1');
        }
        if (!configuration.DisplayOffice) {
            this.ui.office.addClass('hidden');
        }
    },
    text: function (geography, index, path, type) {
        return type.indexOf(geography) > 0 ? Geographies.get('/' + _.take(index, path.indexOf(geography) + 1).join('/') + '/').get('text') : '';
    }
});

var Layout = Marionette.View.extend({
    behaviors: [{ behaviorClass: Behaviors.Tooltip }, Behaviors.MobileView],
    events: {
        'blur @ui.description': 'description',
        'click #addTopic':"addTopic"
    },
    regions: {
        geography: '#geography',
        type: '#type',
        subtype: '#subtype',
        subject: '#subject'
    },
    template: '#recordClassificationLayout',
    ui: {
        approvalNeededBy: '#approvalNeededBy',
        approval: '#approval',
        prapproval: '#prapproval',
        description: '#description',
        descriptionContainer: '#descriptionContainer'
    },
    modelEvents: {
        "change:topics": "render"
    },
    initialize: function () {
        Validation.bind(this);
    },
    onRender: function () {
        var now = new Date();
        var allowed = now.setDate(now.getDate() + Configuration.DaysForApproval);
        var approval = this.model.get('approvalBy') ? this.date(this.model.get('approvalBy')):'';
        var context = this;
        var creation = new Date(this.model.get('createdOn') || now);
        var max = creation.setDate(creation.getDate() + 365);

        this.ui.descriptionContainer.removeClass(this.model.get('configuration').DisplaySubjectDescription ? 'hidden' : '');
        this.ui.approvalNeededBy.addClass(!this.model.get('configuration').DisplayApprovalNeededBy ? 'hidden' : '');
        this.ui.approval.val(approval);
        this.ui.prapproval.html(approval);
        this.ui.approval.datepicker({
            todayHighlight: true,
            format: 'dd MM yyyy',
            startDate: new Date(),
            endDate: this.date(allowed < max ? allowed : max),
            autoclose: true,
            clearBtn: true
        }).on('changeDate', function (e) {
            context.model.set('approvalBy', e.date || '');
        }).keyup(function(e) {
            if(e.currentTarget.value == '') {
                context.model.set('approvalBy','');
            }
        });

        this.getRegion('geography').show(new Geography(this.options));
    }, 
    date: function (value) {
        return new Date(value).format().replace(/\u200E/gi, '');
    },
    description: function () {
        this.model.set('subjectDescription', this.ui.description.val());
    },
    addTopic: function () {
        RecordAddTopic.start(_.extend(this.options, {record:this.model}));
    }
});

var classifications = function (options) {
    var layout = options.layout;
    var repuporsePlaceholder = options.repuporsePlaceholder;
    var record = options.record;
    var subjects = new Entities.Classifications();
    var subtypes = new Entities.Classifications();
    var types = options.types;
    var context = options;


    Dropdown.show({
        collection: types.clone(),
        placeholder: function () {
            return (repuporsePlaceholder && record.get('type')) || Labels.Select;
        },
        region: layout.getRegion('type'),
        selection: record.get('typeId'),
        tooltip: true,
        onDropdownChanged: function (type) {
            if (record.get("typeId") !== type.id) {
                record.set({
                    'subtypeId': '',
                    'subtype': '',
                    'subjectId': '',
                    'subject': ''
                });
                layout.getRegion('subtype').currentView.$el.find('select').append($(new Option(Labels.Select, -1, true, true)).attr('disabled', 'disabled'));
                layout.getRegion('subject').currentView.$el.find('select').append($(new Option(Labels.Select, -1, true, true)).attr('disabled', 'disabled'));
            }
        },
        onSelectionChanged: function (type) {
            if (type && type.id) {
                record.set({
                    'typeId': type.id,
                    'type': type.get('text')
                });
            }

            subtypes.reset(context.subtypes.clone().filter(function (subtype) {
                return subtype.id.indexOf(type.id) === 0;
            }));
        }
    });
    Dropdown.show({
        autoselect: true,
        collection: subtypes,
        parentCollection: types,
        placeholder: function () {
            return (repuporsePlaceholder && record.get('subtype')) || Labels.Select;
        },
        region: layout.getRegion('subtype'),
        selection: record.get('subtypeId'),
        tooltip: true,
        onDropdownChanged: function (subtype) {
            if (record.get("subtypeId") !== subtype.id) {
                record.set({
                    'subjectId': '',
                    'subject': ''
                });
                layout.getRegion('subject').currentView.$el.find('select').append($(new Option(Labels.Select, -1, true, true)).attr('disabled', 'disabled'));
            }
        },
        onSelectionChanged: function (subtype) {
            if (subtype && subtype.id) {
                record.set('subtypeId', subtype.id);
                record.set('subtype', subtype.get('text'));
            }
            subjects.reset(context.subjects.clone().filter(function (subject) {
                return subject.id.indexOf(subtype.id) === 0;
            }));
        }
    });
    Dropdown.show({
        autoselect: true,
        collection: subjects,
        parentCollection: subtypes,
        placeholder: function () {
            return (repuporsePlaceholder && record.get('subject')) || Labels.Select;
        },
        region: layout.getRegion('subject'),
        selection: record.get('subjectId'),
        tooltip: true,
        onSelectionChanged: function (subject) {
            if (subject && subject.id) {
                record.set('subjectId', subject.id);
                record.set('subject', subject.get('text'));
            }
        }
    });
};


var configure = function (options) {
    var record = options.record;
    var subjects = options.subjects;
    var subtypes = options.subtypes;
    var types = options.types;

    var criteria = '/' + _.last(record.get('countryId').slice(1, -1).split('/')) + '/' + record.get('recordTypeId').replace('_', "") + '/';

    return options.classificationCollection.fetch({
        filter: { _id: { $regex: criteria, $options: 'i' } }
    }).done(function () {
        var classificationByType = options.classificationCollection.groupBy('type');

        types.reset(classificationByType.Type);
        subtypes.reset(classificationByType.Subtype);
        subjects.reset(classificationByType.Subject);
    });
};

module.exports.start = function (options) {
    var region = options.region;
    var record = options.record;
    options.classificationCollection = new Entities.Classifications();
    options.subjects = new Entities.Classifications();
    options.subtypes = new Entities.Classifications();
    options.types = new Entities.Classifications();
    var layout = new Layout({ record: options.record, types: options.types, subtypes: options.subtypes, subjects: options.subjects, model: record, classificationCollection:options.classificationCollection });


    region.show(layout);


    //classifications(_.extend({ types: options.types, subtypes: options.subtypes, subjects: options.subjects, layout: layout, repuporsePlaceholder: true }, options));
    if (record.get('statusTypeId') !== StatusType.Complete && record.get('statusTypeId') !== StatusType.UsersNotified) {

        //layout.listenTo(record, "change:topics", function () {
        //    layout.getRegion('type').reset();
        //    layout.getRegion('subtype').reset();
        //    layout.getRegion('subject').reset();
        //    configure(_.extend({ types: options.types, subtypes: options.subtypes, subjects: options.subjects }, options)).done(function () {
        //        //classifications(_.extend({ types: options.types, subtypes: options.subtypes, subjects: options.subjects, layout: layout, searchSelection: true, repuporsePlaceholder: true, record: record }, options));

        //    });
        //});
        configure(_.extend({ types: options.types, subtypes: options.subtypes, subjects: options.subjects }, options)).done(function () {
            //classifications(_.extend({ types: options.types, subtypes: options.subtypes, subjects: options.subjects, layout: layout, repuporsePlaceholder: true }, options));
        });

    }
};



// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordClassification.js